<template>
  <div class="category-sitemap-main-category">
    <Heading
      tag="h2"
      size="md"
      spaces-bottom
      class="category-sitemap-main-category__headline"
    >
      <nuxt-link
        v-if="!hasChildren"
        class="link"
        :to="`/${mainCategory.path}`"
      >
        {{ categoryHeadline }}
      </nuxt-link>
      <span v-else>{{ categoryHeadline }}</span>
    </Heading>
    <ul class="category-sitemap-main-category__child-categories">
      <li
        v-for="childCategory in childCategories"
        :key="childCategory.productCategory.path"
        class="category-sitemap-main-category__child-category"
      >
        <nuxt-link
          :to="`/${childCategory.productCategory.path}`"
          class="link"
        >
          {{ childCategory.productCategory.name }}
        </nuxt-link>
      </li>
      <template v-if="hasBrands">
        <li
          v-for="(brand, i) in category.brands"
          :key="`category-sitemap-main-category__brand--${i}`"
          class="category-sitemap-main-category__brand"
        >
          <nuxt-link
            :to="brandLink(brand.brand.slug)"
            class="link"
          >
            {{ brand.brand.name }}
          </nuxt-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { Heading } from '@i22-td-smarthome/component-library';

export default {
  name: 'CategorySitemapMainCategory',
  components: {
    Heading,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    categoryHeadline() {
      return this.mainCategory.name;
    },
    childCategories() {
      if (!this.category.children) return null;
      return this.category.children;
    },
    hasBrands() {
      return this.category.brands;
    },
    hasChildren() {
      return this.category.children.length > 0;
    },
    mainCategory() {
      return this.category.productCategory;
    },
  },
  methods: {
    brandLink(brandSlug) {
      return `/smartphones-und-handys/smartphones/_${brandSlug}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.category-sitemap-main-category {
  &__brand,
  &__child-category {
    margin-left: 1.5 * $grid-base;
    margin-bottom: $grid-base;
  }

  &__child-categories {
    list-style: none;
    margin-bottom: 4 * $grid-base;
  }

  &__headline {
    @include font-size(32px, 34px);
  }
}
</style>
